import React from 'react';
import { useRouter } from 'next/router';
import { AuthLayout } from '@/components/layout/layout/AuthLayout';
import { ClaimEvaluated } from '../landing/file-claim';

export const ClaimEvaluationScreen: React.FC = () => {
	const router = useRouter();
	const { evaluated } = router.query;

	return (
		<AuthLayout withCarrousel={false} withEllipsesBg={true}>
			<ClaimEvaluated isApproved={evaluated === 'true'} />
		</AuthLayout>
	);
};
